<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />
    <filter-manager
      :display-advanced="false"
      class="search-bar"
      search-icon="fa fa-sync"
      search-text="Procesar"
      search-container-class="btn-process"
      v-model="model.search.filters"
      :filters="filterManagerConfig"
      @search="onHandlerSearch"
      ref="filterRef"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import ProviderServices from '@/services/api/provider.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@/modules/report/document'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'

export default {
  name: 'ProvidersWithoutVisitRegistryMain',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        collections: {
          academicYears: [],
          providers: [],
          months: [],
        },
        filters: {
          academicYear: null,
          provider: null,
          month: null,
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Informe de proveedores sin registro de visita',
        icon: 'fa-solid fa-magnifying-glass-chart pr-0 font-22 magnifying-glass-icon-m',
        routes: ['Inicio', 'Informe de proveedores sin registro de visita'],
      }
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-3',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'month',
          component: 'custom-drop-down',
          class: 'col-12 col-md-3',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Mes',
          placeholder: 'Mes',
          error: 'El mes es requerido.',
          validations: 'required',
          options: this.model.search.collections.months,
          value: this.model.search.filters.month,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          class: 'col-12 col-md-3',
          validations: null,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    hasValue(param) {
      return param !== null && param !== undefined
    },
    async setFilters() {
      const { data: years } = await AcademicYearServices.getCurrentYearAcademicYears()
      this.model.search.collections.academicYears = [...years]
      this.model.search.filters.academicYear = years[0]
      await this.onChangeAcademicYear()
    },
    async onChangeAcademicYear() {
      this.model.search.filters.provider = null
      await this.getProviders()
      await this.getMonthsInAcademicYear()
    },
    async getProviders() {
      const res = await ProviderServices.getEligibleStudentProviders({
        academicYearId: this.model.search.filters.academicYear?.id,
      })
      this.model.search.collections.providers = res.data
    },
    async getMonthsInAcademicYear() {
      this.model.search.collections.months = (
        await AcademicYearServices.getMonthsInAcademicYear(
          this.model.search.filters.academicYear.id
        )
      ).data
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()
      if (isValid) {
        await this.process()
      }
    },
    async process() {
      if (
        this.hasValue(this.model.search.filters.academicYear?.id) &&
        this.hasValue(this.model.search.filters.month?.id)
      ) {
        await ReportServices.getReport('providerswithoutvisitregistry', {
          academicYearId: this.model.search.filters.academicYear.id,
          month: this.model.search.filters.month.id,
          companyId: this.model.search.filters.provider?.id,
        }).then((res) => DocumentServices.Download(res.data))
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
